import SharePointUpload from '../components/psc/lib/SharePointUpload'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'
import useQualityContents from '../hooks/useQualityContents'

const QaDocumentSharePointUpload = () => {
    useBrowserTabTitle('QA Document SharePoint Upload')

    const {
        updateQaDocument,
    } = useQualityContents()

    return (
        <SharePointUpload
            entityType="Document"
            apiPath="qa_documents"
            statusField="qa_document_status"
            successCallback={(obj) => updateQaDocument(obj)}
        />
    )
}

export default QaDocumentSharePointUpload
